<div class="page-config-container">
  <ng-template [ngIf]="large">
    <scw-mat-button [iconButton]="true" [type]="'standard'" (onClick)="showModal(config_modal)">
      <em class="fas fa-sliders-h"></em>
    </scw-mat-button>
  </ng-template>
  <ng-template [ngIf]="!large">
    <scw-mat-small-button [iconButton]="true" (onClick)="showModal(config_modal)">
      <em class="fas fa-sliders-h"></em>
    </scw-mat-small-button>
  </ng-template>
</div>
<ng-template #config_modal let-modal>
  <div class="modal-header scw-modal-header">
    <h3 class="modal-title scw-header">
      General Configuration
    </h3>
    <button id="close-button" type="button" class="close" aria-label="Close" (click)="onCloseClick()">
      <span aria-hidden="true">
        <em class="fas fa-times"></em>
      </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="modal-section">
      <div class="col-12">
        <div class="row">
          <div class="row">
            <div class="col-12 d-flex flex-column my-4 gap-3" *ngIf="tableConfigHasRow">
              <ng-container *ngFor="let item of tabs[0].table">
                <div *ngIf="item?.isTableRow">
                  <div class="page_configuration_item-left">
                    <scw-mat-checkbox
                      [id]="'table-config-checkbox-' + item.name"
                      [(inputModel)]="item.selected"
                      [disabled]="item.disabled"
                    >
                    </scw-mat-checkbox>
                    <div class="page_configuration_item-left-title">{{ item.title }}</div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="col-12">
              <h6 class="scw-header">
                <em class="fas fa-table"></em>
                Table Configuration
              </h6>
            </div>
            <div class="col-12">
              <div class="label-text">
                {{ tableLabelTranslation }}
              </div>
            </div>
            <div class="col-12">
              <ng-template [ngIf]="isSortable">
                <div
                  cdkDropList
                  class="datatable-list"
                  (cdkDropListDropped)="drop($event, tabs[0].table)"
                  cdkDropListOrientation="vertical"
                  [cdkDropListEnterPredicate]="cdkDropListEnterPredicateColumn"
                >
                  <ng-container *ngFor="let item of tabs[0].table; index as rowIndex">
                    <div class="datatable-box" [class.is-sortable]="isSortable" [id]="item.name" cdkDrag *ngIf="!item?.isTableRow" [cdkDragData]="item">
                      <div class="page_configuration_item-left">
                        <scw-mat-checkbox
                          [id]="'table-config-checkbox-' + item.name"
                          [(inputModel)]="item.selected"
                          [disabled]="item.disabled"
                          (onChange)="changeCheckBox($event, true)"
                        >
                        </scw-mat-checkbox>
                        <div class="page_configuration_item-left-title">{{ item.title }}</div>
                      </div>
                      <em class="fas fa-arrows-alt-v page_configuration_item-drag_icon"></em>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
              <ng-template [ngIf]="!isSortable">
                <div class="datatable-list">
                  <ng-container *ngFor="let item of tabs[0].table; index as rowIndex">
                    <div class="datatable-box" [id]="item.name">
                      <div class="page_configuration_item-left">
                        <scw-mat-checkbox
                          [id]="'table-config-checkbox-' + item.name"
                          [(inputModel)]="item.selected"
                          [disabled]="item.disabled"
                          (onChange)="changeCheckBox($event, true)"
                        >
                        </scw-mat-checkbox>
                        <div class="page_configuration_item-left-title">{{ item.title }}</div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-template>
            </div>
            <div class="col-12">
              <div class="label-text">
                {{ pageHeader.titleKey === 'production_review' ? productionReviewInfoMessage : null }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="buttons-right">
      <scw-mat-button (onClick)="apply(true)" [type]="'standard'">
        Set as Default
      </scw-mat-button>
      <scw-mat-button (onClick)="apply(false)">
        Apply
      </scw-mat-button>
    </div>
  </div>
</ng-template>
<ng-template #unsaved_modal let-modal>
  <div class="modal-header scw-modal-header">
    <h3 class="modal-title scw-header">
      {{ 'general.modal.pageConfiguration.header'  }}
    </h3>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">
        <em class="fas fa-times"></em>
      </span>
    </button>
  </div>
  <div class="modal-body">
    <div class="modal-section">
      <div>
        <em class="fas fa-exclamation-circle modal-info-icon"></em>
      </div>
      <h6 class="scw-header">
        You have unsaved changes. Do you want to apply them before closing?
      </h6>
    </div>
  </div>
  <div class="modal-footer">
    <div class="dont-apply-button">
      <scw-mat-button (onClick)="dontApply()" [type]="'danger'">
        Don't Apply
      </scw-mat-button>
    </div>
    <div class="buttons-right">
      <scw-mat-button (onClick)="apply(false)">
        Apply
      </scw-mat-button>
      <scw-mat-button (onClick)="modal.dismiss()" [type]="'standard'">
        Cancel
      </scw-mat-button>
    </div>
  </div>
</ng-template>
